<template>
  <div class="join-base" >
    <div class="join-image">
      <img :src="'http://'+UrlList" alt="" v-if="UrlList">
    </div>
    <div class="join-content">
      <join-content-item
        v-for="item in List" :key="item.id" :join-item="item"
      >
      </join-content-item>
    </div>
  </div>
</template>

<script>

  import JoinContentItem from "@/views/Join/JoinContentItem";

  export default {
    name: "JoinEnter",
    components: { JoinContentItem,},
    data(){
      return{
        List:{},
        UrlList:{}
      }
    },
    created() {
      this.GetData()
      this.GetUrlData()
    },
    methods:{
      GetData(){
        this.$axios.get('/api/job/getAll').then( res =>{
          this.List=res.data.data
        })
      },
      GetUrlData(){
        this.$axios.get('/api/photo/getBuildBanana',{params:{
            id:31
          }}).then(res=>{
          this.UrlList=res.data.data[0].photoList[0].address;
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .join-base{
    width: 100%;
    .join-image{
      img{
        width: 100%;
        height: 250px;
        object-fit: cover;
      }
    }
    .join-content{
      margin-top: 20px;
      padding-bottom: 10px;
    }
  }
</style>